import { render, staticRenderFns } from "./CategoryABMComponent.vue?vue&type=template&id=636a365c&scoped=true"
import script from "./CategoryABMComponent.js?vue&type=script&lang=js&external"
export * from "./CategoryABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./CategoryABMComponent.vue?vue&type=style&index=0&id=636a365c&prod&scoped=true&lang=scss"
import style1 from "./CategoryABMComponent.vue?vue&type=style&index=1&id=636a365c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a365c",
  null
  
)

export default component.exports